export const OptionalProperty = (value, condition, fallback) => {
    if (value === null)
        return null;
    if (condition) {
        const passes = condition(value);
        if (passes) {
            return value;
        }
        return fallback || null;
    }
    return value;
};
export function emptyIfInvalid(props, generator) {
    const processed = generator(props);
    if (generator.isValid(processed)) {
        return processed;
    }
    else {
        return generator();
    }
}
//# sourceMappingURL=value.js.map